import { buildValidations, validator } from 'ember-cp-validations';
import { dependentKeyCompat } from '@ember/object/compat';
import { A as emberA } from '@ember/array';
import { formatZipcode } from 'ember-simplepractice/helpers/format-zipcode';
import { htmlSafe } from '@ember/template';
import { not, or } from 'macro-decorators';
import Model, { attr, belongsTo } from '@ember-data/model';

const markerKeys = ['street', 'city', 'state', 'zip'];

const Validations = buildValidations({
  street: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.office.street',
      messageKey: 'errors.presence',
    }),
  ],
  state: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.office.state',
      messageKey: 'errors.presence',
    }),
  ],
  city: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.office.city',
      messageKey: 'errors.presence',
    }),
  ],
  zip: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.office.zip',
      messageKey: 'errors.presence',
    }),
  ],
});

export default class OfficeModel extends Model.extend(Validations) {
  @belongsTo('polymorphic/addressable', { polymorphic: true, async: false, inverse: null })
  addressable;

  @attr() city;
  @attr() name;
  @attr() state;
  @attr() street;
  @attr() zip;
  @attr() phone;
  @attr('boolean') isVideo;
  @attr() geolocation;
  @attr('boolean') isPublic;
  @attr() insurancePlaceOfService;

  @not('isPublic') notPublic;

  // @dependentKeyCompat so `@or('coordinates', 'geocodingAddress') mapMarkerLocation`
  // re-evaluates when the underlying @attrs change.
  @dependentKeyCompat
  get coordinates() {
    if (this.geolocation) {
      return [this.geolocation.lat, this.geolocation.lng].join(',');
    } else {
      return undefined;
    }
  }

  @dependentKeyCompat
  get geocodingAddress() {
    let markerProps = {
      street: this.street,
      city: this.city,
      state: this.state,
      zip: this.formattedZip,
    };
    return markerKeys.map(key => markerProps[key]).join(' ');
  }

  @or('coordinates', 'geocodingAddress') mapMarkerLocation;

  get formattedZip() {
    return formatZipcode([this.zip]);
  }

  get formattedDistance() {
    return Math.round(this.distance * 10) / 10;
  }

  get callToBookMessage() {
    let msg = this.phone ? `call ${this.phone}` : `contact the practice directly`;
    return htmlSafe(`<span>To request this appointment,</span><br><span>${msg}</span>`);
  }

  static fieldsFor(_context) {
    let fields = emberA();
    this.fields.forEach((_, v) => fields.pushObject(v));
    fields.removeObject('meta');
    fields.removeObject('client');
    return fields;
  }
}
